import { makeActionCreator } from '../../utils';
import { userActionTypes } from '../actionTypes';

export const updateEmailAddress = makeActionCreator(userActionTypes.UPDATE_EMAIL_ADDRESS, 'emailAddress');

export const updatePassword = makeActionCreator(userActionTypes.UPDATE_PASSWORD, 'password');

export const updateFirstName = makeActionCreator(userActionTypes.UPDATE_FIRSTNAME, 'firstName');

export const updateLastName = makeActionCreator(userActionTypes.UPDATE_LASTNAME, 'lastName');

export const updateFbLoginScope = makeActionCreator(userActionTypes.UPDATE_FB_LOGIN_SCOPE, 'fbLoginScope');

export const setPropsFromHost = makeActionCreator(userActionTypes.SET_PROPS_FROM_HOST, 'propsFromHost');



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/userActionCreators.js